import { APP_NAME } from '../utils/branding';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCreditCard, FaLock, FaShoppingCart, FaTimes } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import CartPaymentModal from '../components/CartPaymentModal';
import './Checkout.css';

const getPhotoDisplayName = (photo) => {
  const name = photo?.name || photo?.title || photo?.filename || `Photo ${photo?.id || ''}`;
  return String(name).split('/').pop() || name;
};

function Checkout() {
  const { items, total, removeItem } = useCart();
  const navigate = useNavigate();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [error, setError] = useState('');

  const handlePay = () => {
    if (items.length === 0) {
      setError('Votre panier est vide.');
      return;
    }

    setError('');
    setShowPaymentModal(true);
  };

  const handlePaymentSuccess = (photoIds, methodLabel, response) => {
    setShowPaymentModal(false);

    if (response?.already_completed) {
      navigate('/payment-history');
    }
  };

  return (
    <div className="checkout-page">
      <section className="checkout-header">
        <Link to="/events" className="checkout-back-link">
          <FaArrowLeft />
          <span>Continuer mes achats</span>
        </Link>
        <div>
          <p className="checkout-kicker">Paiement {APP_NAME}</p>
          <h1>Votre panier</h1>
          <p>Réglez votre commande en toute sécurité avec CinetPay.</p>
        </div>
      </section>

      <div className="checkout-grid">
        <section className="checkout-items-panel">
          <div className="checkout-panel-title">
            <FaShoppingCart />
            <h2>Photos sélectionnées</h2>
          </div>

          {items.length === 0 ? (
            <div className="checkout-empty">
              <p>Aucune photo dans le panier.</p>
              <Link to="/events">Parcourir les événements</Link>
            </div>
          ) : (
            <div className="checkout-items">
              {items.map(item => (
                <div key={item.id} className="checkout-item">
                  <div>
                    <strong>{getPhotoDisplayName(item)}</strong>
                    <span>Photo #{item.id}</span>
                  </div>
                  <div className="checkout-item-side">
                    <strong>{Number(item.price || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} F</strong>
                    <button
                      type="button"
                      onClick={() => removeItem(item.id)}
                      aria-label={`Retirer ${getPhotoDisplayName(item)}`}
                    >
                      <FaTimes />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        <aside className="checkout-summary">
          <h2>Resume</h2>
          <div className="checkout-summary-row">
            <span>Photos</span>
            <strong>{items.length}</strong>
          </div>
          <div className="checkout-summary-row">
            <span>Total</span>
            <strong>{Number(total).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} F</strong>
          </div>
          {error && <div className="error-message checkout-error">{error}</div>}
          <button
            type="button"
            className="checkout-pay-button"
            disabled={items.length === 0}
            onClick={handlePay}
          >
            <FaCreditCard />
            <span>Payer</span>
          </button>
          <p className="checkout-secure-note">
            <FaLock />
            <span>Paiement sécurisé par CinetPay.</span>
          </p>
        </aside>
      </div>

      <CartPaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onSuccess={handlePaymentSuccess}
      />
    </div>
  );
}

export default Checkout;
